import React from 'react';
import { Card } from 'react-bootstrap';
import { currencyFormatter } from '../../../utils/services';
import { Link } from 'react-router-dom';

const PendingClassification = ({ totalExpenses, compact = false }) => {
  const hasPendingAmount = totalExpenses < 0;
  if (!hasPendingAmount) return null;

  return (
    <Link to="/expenses" className="text-white" style={{ textDecoration: 'none' }}>
      <Card
        className={`text-center text-white bg-danger ${compact ? 'mb-0' : 'mb-4'}`}
      >
        <Card.Body className={compact ? 'py-1 px-3' : undefined}>
          <Card.Title as={compact ? 'h6' : 'h5'} className={compact ? 'mb-0 text-nowrap' : undefined}>
            {`${currencyFormatter.format(totalExpenses)} Pendiente por clasificar`}
          </Card.Title>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default PendingClassification;